import * as React from "react";
import { TextProps } from "@chakra-ui/react";
import { Text } from "components";

const Captions: React.FC = () => {
  const props: TextProps = {
    position: "absolute",
    color: "gray.400",
    fontSize: "md"
  };

  return (
    <>
      <Text {...props} left={0} top="calc(50% - 40px)">
        Upper Right
      </Text>

      <Text {...props} right={0} top="calc(50% - 40px)">
        Upper Left
      </Text>

      <Text {...props} left={0} bottom="calc(50% - 40px)">
        Lower Right
      </Text>

      <Text {...props} right={0} bottom="calc(50% - 40px)">
        Lower Left
      </Text>
    </>
  );
};

export default Captions;
